import React from "react";
import { FaSort } from "react-icons/fa";
import { IoFilter, IoSearch } from "react-icons/io5";
import styled from "styled-components";
import { RowDiv } from "../components/Layout";
import { H3, P } from "../components/Typography";

interface Props {}

const Table: React.FC<Props> = () => {
  const list = [
    { title: 1 },
    { title: 2 },
    { title: 3 },
    { title: 4 },
    { title: 5 },
    { title: 6 },
  ];
  return (
    <Background>
      <TableHeader>
        <RowDiv style={{ gap: 8 }}>
          <IoFilter size={20} color="white" />
          <H3>27 Watches</H3>
          <Pill>Chronograph 100</Pill>
          <Pill>36 mm</Pill>
          <Pill>Titanium</Pill>
        </RowDiv>
        <RowDiv style={{ gap: 4 }}>
          <IoSearch size={20} color="white" />
          <FaSort size={20} color="white" />
        </RowDiv>
      </TableHeader>
      <TableBody>
        {list.map((item) => {
          return (
            <Tile>
              <P>{item.title}</P>
            </Tile>
          );
        })}
      </TableBody>
    </Background>
  );
};

const Background = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
`;
const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const Pill = styled.div`
  background-color: white;
  padding: 4px 12px;
  border-radius: 50px;
`;

const TableBody = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
`;

const Tile = styled.div`
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  padding: 16px 18px;
`;

export default Table;
